export default class Household {
  constructor() {
    this.selectedHousehold = {};
    this.summaryGoals = [];
    this.householdGoals = [];
    this.unassignedAccounts = [];
    this.clientGoals = [];
    this.clients = [];
    this.clientAccounts = [];
    this.assignedClAccounts = [];
    this.excludedAccounts = [];
    this.excludedClients = [];
    this.assignDataError = false;
    this.selectedAccountCount = 0;
    this.householdGoalAccounts = [];
    this.householdGoalSummary = {};
    this.hhAccounts = [];
  }
}
